module.exports = __webpack_public_path__ + "static/media/wilson-ng-1-low.f06a075e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banners/wilson-ng-1-low.jpg
// module id = 329
// module chunks = 0